import { Tuple, type Middleware } from '@reduxjs/toolkit';
import Raven from 'raven-js';

import settings from '~/settings';

import ravenMiddleware from './RavenMiddleware';

let middlewares: Tuple<Middleware[]> = new Tuple();

if (settings.sentryUrl) {
  Raven.config(settings.sentryUrl).install();
  middlewares = middlewares.concat(ravenMiddleware);
}

export default middlewares;
